import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/** Styling for the stacked title + label/value rows inside an Account Overview field hover card. */
export const overviewHoverPanelStyles = StyleSheet.create({
	panel: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.xs,
	},
	title: {
		color: THEME.colors.text.dark,
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.xs,
	},
	row: {
		display: 'flex',
		gap: THEME.spacing.md,
		justifyContent: 'space-between',
	},
	rowLabel: {
		color: THEME.colors.text.light,
		flex: 'none',
	},
	rowValue: {
		color: THEME.colors.text.main,
		textAlign: 'right',
	},
});
